/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, embedMediaQuery } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : UNSPLASH ATTRIBUTION : STYLES --------------- ++++++++++ */
export default theme => ({
    unsplash_attribution: {
        position: 'absolute',
        height: '23px',
        bottom: 0,
        overflow: 'hidden',
        zIndex: '1000',
        opacity: '0.75',
        background: theme.color.primary.medium.swatch,
        textAlign: 'center',
        '& a': {
            color: "#ffffff",
            fontSize: '10px'
        },
        '& a:hover': {
            textDecoration: 'underline'
        },
        '@media (max-width: 1500px)':{
            '& a': {
                fontSize: '0.6vw'
            },
        }  
    }
});
